"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Overlay = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3.5 1.5a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-11a2 2 0 00-2-2h-11zm1.25 2.25a1 1 0 00-1 1v8.5a1 1 0 001 1h8.5a1 1 0 001-1v-8.5a1 1 0 00-1-1h-8.5z", clipRule: "evenodd", opacity: "0.72" }),
    react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 18v1.5a3 3 0 003 3h9a3 3 0 003-3v-9a3 3 0 00-3-3H18v6.75c0 2.071-1.831 3.75-4.09 3.75H7.5z", clipRule: "evenodd" }))); };
exports.Overlay = Overlay;
//# sourceMappingURL=overlay.js.map